<template>
  <div class="navMenu">
    <template v-for="navMenu in navMenus">
      <!-- 最后一级菜单 -->
      <el-menu-item v-if="!navMenu.children && !navMenu.hidden" :key="navMenu.path" :data="navMenu" :index="navMenu.path">
        <div class="navMenu-item">
          <i :style="{ fontSize: navMenu.iconSize }" :class="['iconfont', navMenu.icon]"></i>
          <span slot="title">{{ navMenu.title }}</span>
        </div>
      </el-menu-item>

      <!-- 此菜单下还有子菜单 -->
      <el-submenu v-if="navMenu.children && !navMenu.hidden" :key="navMenu.path" :data="navMenu" :index="navMenu.path">
        <template slot="title">
          <div class="navMenu-item">

            <i :style="{ fontSize: navMenu.iconSize }" :class="['iconfont', navMenu.icon]"></i>
            <span slot="title">{{ navMenu.title }}</span>
          </div>
        </template>
        <!-- 递归 -->
        <nav-menu :navMenus="navMenu.children"></nav-menu>
      </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
  name: "NavMenu",
  props: {
    navMenus: {
      type: Array, // 菜单列表
      default: () => [],
    },
  },
};
</script>
<style lang="less" scoped>
.navMenu-item {
  .iconfont {
    margin-right: 10px;

  }
}
</style>



// WEBPACK FOOTER //
// src/components/SliderMenu/SubMenu.vue